import { LandingPage } from '../LandingPage';
import { coachesConfig } from './config';

export default function CoachesLandingPage() {
  return <LandingPage config={coachesConfig} />;
}
